import { DestroyRef, Directive, EffectRef, effect, inject, Injector, input, runInInjectionContext, untracked } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator  } from "@angular/forms";

@Directive({
    selector: "[cannotEqual]",
    providers: [{ provide: NG_VALIDATORS, useExisting: CannotEqualValidatorDirective, multi: true }],
    standalone: true
})

export class CannotEqualValidatorDirective implements Validator {
    readonly cannotEqual = input<any[]>(undefined);

    private readonly destroyRef = inject(DestroyRef);
    private readonly injector = inject(Injector);
    private validatorDepsEffect?: EffectRef;

    constructor() {
        this.destroyRef.onDestroy(() => this.validatorDepsEffect?.destroy());
    }

    registerOnValidatorChange(fn: () => void): void {
        this.validatorDepsEffect?.destroy();
        runInInjectionContext(this.injector, () => {
            this.validatorDepsEffect = effect(() => {
                this.cannotEqual();
                untracked(() => fn());
            });
        });
    }

    validate(control: AbstractControl): ValidationErrors | null {
        if (this.cannotEqual().indexOf(control.value) >= 0) {
             return  { "cannotEqual": `Field cannot be ${control.value}` };
        }

        return null;
    }
}
